import { apiSlice } from "../../app/api/apiSlice";

export const getPublicIneligibleProductsSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getPublicIneligibleProducts: builder.mutation({
			query: (credentials) => ({
				url: `api/v1/loan/public/quick_pricer/ineligible_products/?ob_loan_id=${credentials?.ob_loan_id}&search_id=${credentials?.searchId}`,
				method: "GET",
			}),
		}),
	}),
});

export const { useGetPublicIneligibleProductsMutation } =
	getPublicIneligibleProductsSlice;
